<app-material
    [class]="'z-depth-1'"
    [isLoading]="(isLoading$ | async) || trayRequestPending">
    <div class="header" header>
        <div class="tray-controls">
            <h5 class="title">{{ getName((tray$| async)) }}</h5>
            <div class="controls">
                <app-icon library="material" variant="edit" class="control edit-tray"
                          role="button" tabindex="0" [attr.aria-label]="'generic.buttons.edit' | translate"
                          [placeholder]="'generic.buttons.edit' | translate"
                          (click)="onEditTrayClick()" (keydown.enter)="onEditTrayClick()"
                          (keydown.space)="$event.preventDefault(); onEditTrayClick()"></app-icon>
                <app-icon library="material" variant="add" class="control new-slot"
                          role="button" tabindex="0" [attr.aria-label]="'admin.lifts.details.addSlot' | translate"
                          [placeholder]="'admin.lifts.details.addSlot' | translate"
                          (click)="onCreateNewSlotClick()" (keydown.enter)="onCreateNewSlotClick()"
                          (keydown.space)="$event.preventDefault(); onCreateNewSlotClick()">
                </app-icon>
            </div>
            <app-icon variant="filter_list" class="filter-action" role="button" tabindex="0"
                      [class.active]="filtersExpanded" [attr.aria-expanded]="filtersExpanded"
                      aria-controls="tray-tool-filter-form" [attr.aria-label]="'admin.lifts.details.filterSlots' | translate"
                      [placeholder]="'admin.lifts.details.filterSlots' | translate" (click)="toggleFilters()"
                      (keydown.enter)="toggleFilters()" (keydown.space)="$event.preventDefault(); toggleFilters()"></app-icon>
        </div>
        <app-lift-tool-filters *ngIf="filtersExpanded" id="tray-tool-filter-form"
                               [form]="filterForm"
                               [allLinesLabel]="'admin.lifts.filters.allLines' | translate"
                               [lines]="lines$ | async"></app-lift-tool-filters>
        <div class="slot-controls">
                <span *ngIf="trayLoadFailed" role="alert">{{ 'admin.lifts.details.trayLoadError' | translate }}</span>
                <span *ngIf="filterError" role="alert">{{ 'admin.lifts.details.slotFilterError' | translate }}</span>
                <span *ngIf="!trayRequestPending && !filteringSlots && !filterError && !trayLoadFailed && !visibleSlots.length">
                    {{ 'admin.lifts.details.noMatchingSlots' | translate }}
                </span>
            <ng-container *ngIf="!trayRequestPending && !filterError">
                <ng-container *ngFor="let slot of visibleSlots">
                    <app-slot
                        [id]="slot.id"
                        [slot]="slot"
                        [selected]="slot?.id === (slot$ | async)?.id"
                        [hasSettings]="true"
                        (edit)="onSlotEditClick(slot)"
                        (delete)="onSlotDeleteClick(slot)"
                        (duplicate)="onSlotDuplicateClick(slot)"
                        (copy)="onSlotCopyClick(slot)"
                        (settings)="onSlotSettingsClick($event)"
                        (select)="onSlotSelect($event)">
                    </app-slot>
                </ng-container>
            </ng-container>
        </div>
        <div class="batch-controls">
            <div class="batches"
                 *ngIf="!filteringSlots && !filterError && !selectingInitialBatch && selectedSlot && (slot$ | async)?.batches as batches">
                <span class="all-tools"
                      [class.selected]="this.selectedBatch === null"
                      (click)="onSelectAllTools(toolConfig)">
                    {{ 'admin.lifts.batches.allTools' | translate }}
                </span>
                <span class="batch-title">{{ 'admin.lifts.details.batches' | translate }}:</span>
                <app-batch [batch]="batch"
                           [hasSettings]="true"
                           [selected]="this.selectedBatch?.id === batch.id"
                           (settings)="onBatchSettingsClick($event)"
                           (select)="onSelectBatch($event)"
                           (delete)="onRemoveBatch(batch)"
                           (edit)="onEditBatchClick(batch)"
                           (duplicate)="onDuplicateBatchClick(batch)"
                           *ngFor="let batch of batches">
                </app-batch>
            </div>
            <div class="batch-btn-control" *ngIf="!filteringSlots && !filterError && !selectingInitialBatch && selectedSlot && (tools$ | async) as tools">
                <app-icon *ngIf="(batch$ | async) === null && selectedSlot"
                          library="material" variant="playlist_add" role="button"
                          [class.disabled]="!selectedTools.length" [attr.aria-disabled]="!selectedTools.length"
                          [attr.tabindex]="selectedTools.length ? 0 : -1"
                          [placeholder]="'admin.lifts.batches.addToolsToBatch' | translate"
                          [attr.aria-label]="'admin.lifts.batches.addToolsToBatch' | translate"
                          (click)="openAddToBatchModal()" (keydown.enter)="openAddToBatchModal()"
                          (keydown.space)="$event.preventDefault(); openAddToBatchModal()"></app-icon>
                <app-icon *ngIf="(batch$ | async) === null && selectedSlot"
                          library="material" variant="content_copy" role="button" tabindex="0"
                          [placeholder]="'admin.lifts.batches.copyBatches' | translate"
                          [attr.aria-label]="'admin.lifts.batches.copyBatches' | translate"
                          (click)="openCopyBatchesModal()" (keydown.enter)="openCopyBatchesModal()"
                          (keydown.space)="$event.preventDefault(); openCopyBatchesModal()"></app-icon>
                <app-icon *ngIf="(batch$ | async) !== null && this.selectedTools"
                          library="material" variant="shopping_cart" role="button"
                          [class.disabled]="!selectedTools.length" [attr.aria-disabled]="!selectedTools.length"
                          [attr.tabindex]="selectedTools.length ? 0 : -1"
                          [placeholder]="'admin.lifts.batches.updateCart' | translate"
                          [attr.aria-label]="'admin.lifts.batches.updateCart' | translate"
                          (click)="openUpdateCartModal()" (keydown.enter)="openUpdateCartModal()"
                          (keydown.space)="$event.preventDefault(); openUpdateCartModal()"></app-icon>
                <app-icon *ngIf="(batch$ | async) !== null && this.selectedTools"
                          library="material" variant="remove_circle_outline" role="button"
                          [class.disabled]="!selectedTools.length" [attr.aria-disabled]="!selectedTools.length"
                          [attr.tabindex]="selectedTools.length ? 0 : -1"
                          [placeholder]="'admin.lifts.batches.removeToolsFromBatch' | translate"
                          [attr.aria-label]="'admin.lifts.batches.removeToolsFromBatch' | translate"
                          (click)="openRemoveFromBatchModal()" (keydown.enter)="openRemoveFromBatchModal()"
                          (keydown.space)="$event.preventDefault(); openRemoveFromBatchModal()"></app-icon>
            </div>
        </div>
    </div>
    <ng-container body>

        <!-- Tool table -->
        <ng-container *ngIf="!filteringSlots && !filterError && !selectingInitialBatch && this.selectedBatch === null && this.selectedSlot"
                      [ngTemplateOutlet]="toolsTable"
                      [ngTemplateOutletContext]="{tools: tools}">
        </ng-container>

        <ng-container *ngIf="!filteringSlots && !filterError && !trayLoadFailed && !this.selectedSlot">
            <h5 class="no-slot-message">{{ 'admin.lifts.noSLotMessage' | translate }}</h5>
        </ng-container>

        <!-- Batch table -->
        <ng-container *ngIf="!filteringSlots && !filterError && !selectingInitialBatch && this.selectedSlot && this.selectedBatch"
                      [ngTemplateOutlet]="batchTable"
                      [ngTemplateOutletContext]="{batch: selectedBatch}">
        </ng-container>

    </ng-container>
    <ng-container footer #materialFooter>
    </ng-container>
</app-material>


<app-to-batch-modal [title]="'admin.lifts.batches.addToolsToBatch' | translate"
                    [isLoading]="isLoading$ | async"
                    [tools]="selectedTools"
                    [batches]="(slot$| async)?.batches"
                    (addToBatch)="addToolsToBatch($event)"
                    (addToNewBatch)="addToolsToNewBatch($event)">
</app-to-batch-modal>
<app-from-batch-modal [title]="'admin.lifts.batches.removeToolsFromBatch' | translate"
                      [isLoading]="isLoading$ | async"
                      [tools]="selectedTools"
                      [batch]="(batch$| async)"
                      (removeFromBatch)="removeFromBatch($event)">
</app-from-batch-modal>

<app-from-batch-modal [title]="'admin.lifts.batches.removeToolsFromBatch' | translate"
                      [isLoading]="isLoading$ | async"
                      [tools]="selectedTools"
                      [batch]="(batch$| async)"
                      (removeFromBatch)="removeFromBatch($event)">
</app-from-batch-modal>

<app-rename-cart-modal [title]="'admin.lifts.batches.updateCart' | translate"
                       [isLoading]="isLoading$ | async"
                       [tools]="selectedTools"
                       [batch]="(batch$| async)"
                       (updateCart)="updateCart($event)">
</app-rename-cart-modal>

<app-edit-slot-modal title="{{'admin.lifts.batches.editSlot' | translate}}"
                     [isLoading]="isLoading$ | async"
                     (editSlot)="onEditSlot($event)">
</app-edit-slot-modal>

<app-edit-tray-modal [isLoading]="isLoading$ | async"
                     (editTray)="onEditTray($event)">
</app-edit-tray-modal>

<app-confirmation-modal title="{{'admin.lifts.notifications.confirmRemoveBatch' | translate }}"
                        question="{{'admin.lifts.notifications.confirmRemoveBatchQuestion' | translate: {batchName: toDeleteBatch?.name} }}"
                        [showConfirmButton]="true"
                        [isConfirmationInProgress]="isLoading$ | async"
                        (confirmEvent)="onConfirmRemoveBatch()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-confirmation-modal #deleteSlotConfirmationModal
                        title="{{'admin.lifts.notifications.confirmRemoveSlot' | translate }}"
                        question="{{'admin.lifts.notifications.confirmRemoveSlotQuestion' | translate: {slotName: toDeleteSlot?.name} }}"
                        [showConfirmButton]="true"
                        [isConfirmationInProgress]="isLoading$ | async"
                        (confirmEvent)="onConfirmRemoveSlot()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-edit-batch [isLoading]="isLoading$ | async"
                (editBatch)="onEditBatch($event)">
</app-edit-batch>

<app-copy-batches-modal>
</app-copy-batches-modal>

<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="errorMessagePopup"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>

<app-copy-slot-modal [isLoading]="isLoading$ | async">
</app-copy-slot-modal>

<ng-template #toolsTable let-tools="tools">
    <app-lift-tools-table class="tools"
                          [toolsGrouped]="tools"
                          [selectedTools]="selectedTools"
                          [isLoading]="isLoadingTools$ | async"
                          [tableConfig]="toolConfig"
                          [showFilters]="true"
                          [showGroupFilters]="false"
                          [showGroupers]="false"
                          [isFilterExpanded]="false"
                          [isMaterial]="false"
                          (sortChange)="onToolsSortChange($event)"
                          (filterChange)="onToolsFilterChange($event)"
                          (filterGroupChange)="onToolsFilterGroupChange($event)"
                          (groupChange)="onToolsGroupChange($event)"
                          (pageChange)="onToolsPageChange($event)"
                          (onToolClicked)="onToolClicked($event)">
    </app-lift-tools-table>
</ng-template>

<ng-template #batchTable let-batch="batch">
    <app-lift-tools-table class="tools batch-table"
                          [toolsGrouped]="batch?.tools?.tools"
                          [selectedTools]="selectedTools"
                          [isLoading]="isLoadingTools$ | async"
                          [tableConfig]="batchConfig"
                          [showFilters]="false"
                          [showGroupFilters]="false"
                          [showGroupers]="false"
                          [isFilterExpanded]="false"
                          [isMaterial]="false"
                          [hasTitle]="false"
                          [allExpanded]="false"
                          (sortChange)="onBatchesPageChange($event, batch.id)"
                          (filterChange)="onBatchesFilterChange($event, batch.id)"
                          (pageChange)="onBatchesPageChange($event, batch.id)"
                          (onToolClicked)="onToolClicked($event)">
    </app-lift-tools-table>
</ng-template>
